export const hyphenate = (string, regex = /\s/g) => string.replace(regex, "-");

export const hashParamsBrandId = location =>
  window.btoa(
    JSON.stringify({
      location,
    })
  );
